module.exports = __webpack_public_path__ + "static/media/bus-echtzeit~FOchepzn.74cf48f0.svg";